/**
 * Eventbus helper plugin for VueJsaa
 */
const isDevelopment = import.meta.env.MODE !== 'production';
const SHOW = false;
const SHOW_LISTEN = SHOW && isDevelopment && true;
const SHOW_LISTEN_ONCE = SHOW && isDevelopment && true;
const SHOW_REMOVE = SHOW && isDevelopment && true;
const SHOW_PUBLISH = SHOW && isDevelopment && true;

export default {
  $eventBus: null,

  install(Vue) {
    this.$eventBus = new Vue();
  },

  listen(eventClass, handler, scope) {
    if (scope) {
      handler.$scoped = (event) => handler.call(scope, event);
      this.$eventBus.$on(eventClass.name, handler.$scoped);
    } else {
      this.$eventBus.$on(eventClass.name, handler);
    }
    if (SHOW_LISTEN) {
      console.log('listen::', eventClass.name);
    }
  },

  listenOnce(eventClass, handler, scope) {
    if (scope) {
      handler.$scoped = (event) => handler.call(scope, event);
      this.$eventBus.$once(eventClass.name, handler.$scoped);
    } else {
      this.$eventBus.$once(eventClass.name, handler);
    }
    if (SHOW_LISTEN_ONCE) {
      console.log('listenOnce::', eventClass.name);
    }
  },

  remove(eventClass, handler) {
    if (handler) {
      let callback = handler.$scoped ? handler.$scoped : handler;
      this.$eventBus.$off(eventClass.name, callback);
    } else {
      this.$eventBus.$off(eventClass.name);
    }
    if (SHOW_REMOVE) {
      console.log('remove::', eventClass.name);
    }
  },

  removeAll() {
    this.$eventBus.$off();
    if (isDevelopment) {
      console.log('removeAll');
    }
  },

  publish(event) {
    this.$eventBus.$emit(event.constructor.name, event);
    if (SHOW_PUBLISH) {
      console.log('publish::', event.constructor.name);
    }
  }
};
